import SearchSuggestion from './SearchSuggestion.gql';

export default SearchSuggestion;
